<template>
    <div class="AccountAssets">
        <div class="nav">
            <div class="nav-item" :class="accountType == 1 ? 'active-nav-item' : ''" @click="changeAccount(1)">{{
                $t('AccountAssets.text90') }}</div>
            <div class="nav-item" :class="accountType == 2 ? 'active-nav-item' : ''" @click="changeAccount(2)">{{
                $t('AccountAssets.text91') }}</div>
            <div class="nav-item" v-show="!noMt4List" :class="accountType == 3 ? 'active-nav-item' : ''"
                @click="changeAccount(3)">{{
                    $t('AccountAssets.text92') }}</div>
            <div class="nav-item" v-show="!noMt4DemoList" :class="accountType == 4 ? 'active-nav-item' : ''"
                @click="changeAccount(4)">{{
                    $t('AccountAssets.text93') }}</div>
        </div>
        <div v-for="item in dataList" :key="item.fundAccountId">
            <AssetsLiveAccount :data="item" :accountType="accountType" />
        </div>
    </div>
</template>
<script>
import {
    ref, onMounted, computed, onBeforeUnmount
} from 'vue';
import apiServer from "@/api/request";
import { useStore } from 'vuex'
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import AssetsLiveAccount from './components/AssetsLiveAccount'
export default {
    name: "AccountAssets",
    components: {
        AssetsLiveAccount
    },
    setup() {
        const activeType = ref('1');
        const store = useStore();
        const dataList = ref([]);
        const accountType = ref(1);
        const userToken = computed({ get: () => store.getters.userToken });
        let timer;
        const { t } = useI18n()

        const noMt4List = ref(true);
        const noMt4DemoList = ref(true);

        GetAllAccountList();

        function GetAllAccountList() {
            apiServer.GetAllAccountList().then(res => {
                console.log("GetAllAccountList", res)
                if (res.status == 1) {
                    if (res.data.mt4List.length > 0) {
                        noMt4List.value = false;
                    }
                    if (res.data.mt4DemoList.length > 0) {
                        noMt4DemoList.value = false;
                    }
                }
            })
        }
        //web 实盘
        function getUserBalance() {
            let params = {
                usertoken: localStorage.userToken,
            }
            apiServer.getUserAllWebBalance(params).then(res => {
                if (res.status == 1) {
                    dataList.value = res.data;
                }
            })
        }
        //web模拟盘
        function getUserBalanceDemo() {
            let params = {
                usertoken: localStorage.userToken
            }
            apiServer.getUserBalanceDemo(params).then(res => {
                if (res.status == 1) {
                    dataList.value = [res.data]
                }
            })
        }
        //MT4 实盘
        function getUserAllMT4Balance() {
            let params = {
                usertoken: localStorage.userToken,
                type: accountType.value == 3 ? 1 : ''
            }
            console.log('params', params)
            apiServer.getUserAllMT4Balance(params).then(res => {
                if (res.status == 1) {
                    console.log(res.data)
                    dataList.value = res.data;
                }
            })
        }
        onMounted(() => {
            if (userToken.value) {
                getUserBalance()
                timer = setInterval(() => {
                    getUserBalance()
                }, 5000);
            }
        })

        onBeforeUnmount(() => {
            clearInterval(timer);
            timer = null;
        })

        function changeAccount(e) {
            if (e == 2) {
                apiServer.SwitchQuoteInfo().then((res) => {
                    let status = res.data.demo.status;
                    if (status == 2 || status == 3) {
                        ElMessage({
                            message: t("trade.text148"),
                            type: "error",
                        });
                        return;
                    } else {
                        accountType.value = e;
                        clearInterval(timer);
                        timer = null;
                        dataList.value = [];
                        getUserBalanceDemo()
                        timer = setInterval(() => {
                            getUserBalanceDemo()
                        }, 5000)
                    }
                });
            } else {
                clearInterval(timer);
                timer = null;
                accountType.value = e;
                dataList.value = [];
                if (e == 1) {
                    getUserBalance()
                    timer = setInterval(() => {
                        getUserBalance()
                    }, 5000)
                } else if (e == 3 || e == 4) {
                    getUserAllMT4Balance()
                    timer = setInterval(() => {
                        getUserAllMT4Balance()
                    }, 5000)
                }
            }
        }
        return {
            noMt4List,
            changeAccount,
            activeType,
            dataList,
            accountType,
            getUserAllMT4Balance,
            noMt4DemoList
        }
    }
}
</script>
<style lang="less" scoped>
.AccountAssets {
    .nav {
        display: flex;
        justify-content: space-around;
        padding-top: 10px;
        border-bottom: 1px solid #D3DAE2;
        margin-bottom: 32px;

        .nav-item {
            width: 220px;
            height: 50px;
            text-align: center;
            line-height: 48px;
            font-size: 18px;
            font-weight: 500;
            color: #666D7F;
            border-radius: 4px 4px 0px 0px;
            border-top: 1px solid #D3DAE2;
            border-left: 1px solid #D3DAE2;
            border-right: 1px solid #D3DAE2;
            position: relative;
            bottom: -1px;
            cursor: pointer;
            background-color: #F8F8F8;

        }

        .active-nav-item {
            background: rgba(81, 180, 241, 0.10);
            color: #51B4F1;
            border-bottom: 1px solid white;

        }
    }
}
</style>